import CultureSelection from './CultureSelection';
import DateFormatSelection from './DateFormatSelection';
import TimeFormatSelection from './TimeFormatSelection';
import TimeZoneSelection from './TimeZoneSelection';
import { observer } from 'mobx-react';
import * as React from 'react';

@observer
export default class RegionalFull extends React.Component<{}, {}> {
    render() {
        return (
            <div>
                <CultureSelection />
                <DateFormatSelection showExampleWithDateFormatLabel={true} />
                <TimeFormatSelection />
                <TimeZoneSelection />
            </div>
        );
    }
}
